import React, { createContext } from 'react';
import { usePersistedSessionState } from '@edreamsodigeo/frontend-core';
import { useGetShoppingCart } from '@/hooks/GQL';

export const RepricingContextDesktop = createContext(null);

function useRepricingInfoQuery() {
  const [bookingId] = usePersistedSessionState('bookingId');
  const { data, loading } = useGetShoppingCart({
    bookingId,
  });

  return {
    loading,
    repricing: {
      difference: {
        amount: data?.getShoppingBundle?.repricing?.difference,
      },
    },
  };
}

export function RepricingInfoDesktop({ children }) {
  return (
    <RepricingContextDesktop.Provider value={useRepricingInfoQuery()}>
      {children}
    </RepricingContextDesktop.Provider>
  );
}
